import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import * as constants from "../services/content/content";

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  constructor() {}

  public currentStep = new BehaviorSubject(1);
}
